import { AuthState } from '@/app/shared/interfaces';

export const initialAuthState: AuthState = {
    user: null,
    tokens: {
        accessToken: null,
        refreshToken: null,
    },
    challenge: {
        authChallengeToken: null,
        challengeType: null,
        challengeReason: null,
        challengeDelivery: null,
    },
    isLoggedIn: false,
    isLoading: false,
    error: null,
    initialized: false,
};
